import clsx from "clsx";
import { DetailedHTMLProps, HTMLAttributes, useEffect } from "react";
import { Product } from "~src/types/Algolia";
import { formatLocaleString } from "~src/utils/formatLocaleString";
import * as classes from "./ProductPrice.module.css";
import { usePLPContext } from "../../ProductListingPage/ProductListingPage";

type ProductPriceProps = {
  product: Product;
  currency: string;
  forceWishlist: boolean;
};
 
type ProductPriceComponentProps = ProductPriceProps &
  Omit<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    keyof ProductPriceProps
  >;

export const ProductPrice = ({
  product,
  currency,
  className,
  forceWishlist,
  ...props
}: ProductPriceComponentProps) => {
  const { b2b, visual_percentage_off_tab } = usePLPContext();

  const isSupplement = product.tags.some((tag) => tag.toLowerCase().includes('all products: supplements')); //Check if Supplement Product

  let enableVisualDiscount = false
 
  if(visual_percentage_off_tab){
    enableVisualDiscount = true
  }else if(window?.sale != null && window?.sale > 0 && window?.sale_tag != null && !window?.B2B){ // && product.product_type != "Gift Cards"){
    enableVisualDiscount = product.tags.some((tag) => tag.toLowerCase().includes(window?.sale_tag)); //Check if Product has window sale tag
  }else if(window?.sale != null && window?.sale > 0 && !window?.B2B){ // && product.product_type != "Gift Cards"){
    enableVisualDiscount = true
  }

  const isGiftCard = product.product_type == "Gift Cards"

  // const visualPercentageApplies = product.compare_at_price == 0 
  //   ?
  //     false
  //     window?.sale > 0 && enableVisualDiscount == true
  //     ? 
  //       true 
  //     : 
  //       false
  //   :
  //     Math.round( (1 - product.price / product.compare_at_price) * 100 ) < window?.sale
  //   ;
  
  const visualPercentageApplies = b2b ? true : product.compare_at_price == 0 && enableVisualDiscount

  // const salePercentage = !visualPercentageApplies ? Math.round( (1 - product.price / product.compare_at_price) * 100 ) : Math.round( window?.sale/100 * 100 );
  const salePercentage = !visualPercentageApplies
    ?  
      Math.round( (1 - product.price / product.compare_at_price) * 100 )
    :
      b2b ? 
        (b2b == 'facets.On_b2b_mode2' || b2b == 'facets.On_b2b_mode3') ? 
          Math.round( 40/100*100 ) 
        : 
          Math.round( 50/100*100 )
      : 
        Math.round( window?.sale/100 * 100 )
      // b2b ? () => {
      //   if(b2b == 'facets.On_b2b_mode2' || b2b == 'facets.On_b2b_mode3'){
      //     return Math.round( 40/100*100 )
      //   }else{
      //     return Math.round( 50/100*100 )
      //   }
      // } : Math.round( window?.sale/100 * 100 )
  ;
    
  const onSale = visualPercentageApplies ? true : product.price < product.compare_at_price;
  const noCompare = visualPercentageApplies ? (isGiftCard ? true : false) : !product.price_varies && product.compare_at_price_varies;


  // const current_compare_at_price = isSupplement && product.compare_at_price == 0 ? product.price : product.compare_at_price
  // const current_price = isSupplement && product.compare_at_price == 0 ? product.price * 0.8 : product.price
  
  // const salePercentage = !visualPercentageApplies
  //   ?  
  //     Math.round( (1 - current_price / current_compare_at_price) * 100 )
  //   :
  //     Math.round( window?.sale/100 * 100 )
  //   ;
    
  // const onSale = visualPercentageApplies ? true : current_price < current_compare_at_price;
  // const noCompare = visualPercentageApplies ? false : !product.price_varies && product.compare_at_price_varies;

  const formatPrice = (price: number) => {
    if (window.default_currency === currency) {
      return price;
    } else {
      return window.Currency?.convert(price, window.default_currency, currency);
    }
  };

  // Custom pill for products.
  const saleTag = product.tags.find((tag) => tag.startsWith("sale:"));
  // const saleTag = 'sale:AP25 - 25% OFF:#9b5de5:#feeb08';
  let saleTagArray = [];
  if(saleTag){
    saleTagArray = saleTag.split(":");
  }

  const promoBadgeAllowedOnSaleItems = (!onSale || window.productStrings.productPromoBadgeAllowSale) && b2b == ''

  const promoBadgeHasSpecificTag = window.productStrings.productPromoBadgeSpecificTag ? product.tags.some((tag) => tag.toLowerCase().includes(window.productStrings.productPromoBadgeSpecificTag.toLowerCase())) : true

  const compare_at_price = visualPercentageApplies ? 
    b2b && product.price < product.compare_at_price ? 
      product.compare_at_price :  
      product.price : 
    product.compare_at_price
  const product_price = visualPercentageApplies ? (1 - ((b2b ? (b2b == 'facets.On_b2b_mode2' || b2b == 'facets.On_b2b_mode3' ? Math.round( 40 ) : Math.round(50)) : parseInt(visual_percentage_off_tab) ? parseInt(visual_percentage_off_tab) : window.sale) / 100)) * (product.price < product.compare_at_price && b2b ? product.compare_at_price : product.price) : product.price

  return (
    <div
      {...props}
      className={clsx(
        classes.price + ' price ',
        { [classes.onSale]: onSale, [classes.noCompare]: noCompare },
        className
      )}
    >
      <div className={classes.regularPrice + ' regularPrice'}>
        <span className="visually-hidden visually-hidden--inline">
          {window.productStrings.regularPrice}
        </span>
        <span>
          {product.price_varies && "From "}
          {formatPrice(product.price)?.toLocaleString(navigator.language, {
            currency,
            currencyDisplay: "symbol",
            style: "currency",
          })}
        </span>
      </div>
      <div className={classes.salePrice + ' salePrice'}>
        <span className="visually-hidden visually-hidden--inline">
          {window.productStrings.regularPrice}
        </span>
        {(product.compare_at_price != 0 && !enableVisualDiscount || enableVisualDiscount || b2b) && (
          <s>
            <span>
              {formatPrice(compare_at_price)?.toLocaleString(
                navigator.language,
                {
                  currency,
                  currencyDisplay: "symbol",
                  style: "currency",
                }
              )}
            </span>
          </s>
        )}
        <span className="visually-hidden visually-hidden--inline">
          {window.productStrings.salePrice}
        </span>
        <span>
          {formatPrice(product_price)?.toLocaleString(navigator.language, {
            currency,
            currencyDisplay: "symbol",
            style: "currency",
          })}
        </span>
        
        {!visual_percentage_off_tab && (
          <span className={classes.saleBadge} aria-hidden="true">
            {formatLocaleString(window.productStrings.save, {
              label: window.productStrings.saleText,
              percentage: salePercentage,
            })}
          </span>
        )}
        
        {/* {visualPercentageApplies && window?.sale_text && (
          <span className={classes.saleBadge} aria-hidden="true">
            {window?.sale_text}
          </span>
        )} */}

      </div>
      
      {/* Promo Badge */}
      {!isGiftCard && promoBadgeAllowedOnSaleItems && promoBadgeHasSpecificTag && window.productStrings.productPromoBadgeEnable && !visual_percentage_off_tab && (
        <span className={classes.saleBadge + ` promoBadge`} aria-hidden="true" style={{
          backgroundColor: window.productStrings.productPromoBadgeBackgroundColour,
          color: window.productStrings.productPromoBadgeTextColour
        }}>
          { window.productStrings.productPromoBadgeText }
        </span>
      )}

      
        {saleTagArray.length && !visual_percentage_off_tab ? (
          <span className={classes.saleTag} style={
            {
              backgroundColor: saleTagArray[2],
              color: saleTagArray[3]
            }
          }>{saleTagArray[1]}</span>
        ):(<></>)}
        {forceWishlist && visual_percentage_off_tab ? (
          <span className={clsx(classes.promotionBadge, classes.saleBadge)}>Save {visual_percentage_off_tab}%</span>
        ):
          forceWishlist &&(
            <span className={clsx(classes.promotionBadge, classes.saleBadge)}>
              <>{window.productStrings.promoText}</>
            </span>
          )
        }
    </div>
  );
};
